import { render, staticRenderFns } from "./technicalAdvantage.vue?vue&type=template&id=f67c98d2&scoped=true"
import script from "./technicalAdvantage.vue?vue&type=script&lang=js"
export * from "./technicalAdvantage.vue?vue&type=script&lang=js"
import style0 from "./technicalAdvantage.vue?vue&type=style&index=0&id=f67c98d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c98d2",
  null
  
)

export default component.exports